import React, { useState } from "react";
import { Link } from "react-router-dom";
import useAuth from "../Auth/useAuth";

const NavbarComponent = () => {
  const { user, userType, logout } = useAuth();
  const [openMenu, setOpenMenu] = useState(false);

  const buttonHandle = () => {
    setOpenMenu((openMenu) => (openMenu = !openMenu));
  };
  return (
    <div>
      <header className="text-[#ffffff] bg-blue-900 body-font">
        <div className="h-10 ml-2 lg:hidden md:hidden flex justify-between items-center">
          <div className="text-2xl font-bold flex justify-center">BISSS-8B</div>
          <div className="">
            <button onClick={buttonHandle}>
              <img
                src="./assets/menu.png"
                alt="pic"
                className="h-6 w-8 mt-2 mr-2"
              />
            </button>
          </div>
        </div>
        <div className="relative lg:py-5 bg-[#ffffff] ">
          <div className="grid grid-cols-7 text-center">
            <div className="lg:pl-20 md:pl-20 hidden md:block lg:block ">
              <img src="./assets/as_logo.png" alt="pic" className="h-32 w-32" />
            </div>

            <div className="flex flex-wrap flex-col lg:col-span-5 md:col-span-5 col-span-7 ">
              <div className="block lg:hidden md:hidden mx-auto">
                <img
                  src="./assets/as_logo.png"
                  alt="pic"
                  className="h-32 w-32"
                />
              </div>
              <h1 className="lg:text-5xl md:text-5xl text-2xl text-black font-bold text-center ">
                Bokaro Ispat Senior Secondary School-8B
              </h1>
              <div className="flex justify-center items-center">
                <h1 className=" text-base text-center uppercase mt-3 font-semibold  text-black ">
                  School Code :- 8B
                </h1>
                <span className="ml-5 text-base mt-3 uppercase text-center font-semibold text-black">
                  CBSE Affiliation NO. :- 3430077
                </span>
              </div>
              <h1 className="text-center font-semibold text-black lg:text-xl text-sm">
                NEAR SURYA MANDIR BOKARO STEEL CITY, BOKARO JHARKHAND-827009
              </h1>
            </div>
            <div className="hidden md:block lg:block ">
              <img src="./assets/sail.png" alt="pic" className="h-32 w-32" />
            </div>
          </div>
        </div>

        {/* Nav  Start */}
        <nav className="flex-col flex-grow h-10 md:pb-0 hidden md:flex  md:flex-row  md:justify-center items-center">
          <ul className="flex">
            <Link to={"/home"}>
              <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 duration-150  hover:cursor-pointer hover:scale-125 mb-1 md:mb-0">
                <span className="font-semibold">Home</span>
              </li>
            </Link>
            <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 hover:cursor-pointer hover:scale-125 z-10 mb-1 md:mb-0  ">
              <span className="firstlevel font-semibold whitespace-no-wrap text-white-600">
                About Us
              </span>

              <ul className="absolute left-0 top-1 mt-8 shadow-lg bg-blue-900 z-10 hidden group-hover:block box-border h-32 w-32 p-2 ">
                <li className="p-1 whitespace-no-wrap rounded-full text-sm md:text-base text-white-600 hover:text-yellow-300">
                  <Link to={"/aboutUs"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      About BISSS
                    </span>
                  </Link>
                </li>
                <Link to={"/schoolManagementCommittee"}>
                  <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                    <span className="flex  text-base">
                      School Management Committee
                    </span>
                  </li>
                </Link>
              </ul>
            </li>
            <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 hover:cursor-pointer hover:scale-125 z-10 mb-1 md:mb-0  ">
              <span className="firstlevel font-semibold whitespace-no-wrap text-white-600">
                Admission
              </span>

              <ul className="absolute left-0 top-1 mt-8  shadow-lg bg-blue-900 z-10  hidden group-hover:block box-content h-45 w-32 p-2 ">
                <li className="p-1 whitespace-no-wrap rounded-full text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/feestructure"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Fee Structure
                    </span>
                  </Link>
                </li>
                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/acadenicsession"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Academics Session
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            <Link to={"/activities"}>
              <li className="relative mx-1 px-1 py-2 group mr-6 text-white-600 hover:cursor-pointer hover:scale-125 mb-1 md:mb-0 duration-150">
                <span className="font-semibold">Activities</span>
              </li>
            </Link>
            <li className="relative mx-1 px-1 py-2 group mr-6  text-white-600 hover:cursor-pointer hover:scale-125 duration-150 z-10  mb-1 md:mb-0">
              <span className="firstlevel font-semibold whitespace-no-wrap text-white-600">
                Facilities
              </span>

              <ul className="absolute left-0 top-1 mt-8 shadow-lg bg-blue-900 z-10  hidden group-hover:block box-content h-45 w-32 p-2 ">
                <li className="p-1 whitespace-no-wrap rounded-full text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/indoorgames"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Indoor Games
                    </span>
                  </Link>
                </li>
                <li className="p-1 whitespace-no-wrap rounded-full text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/outdoorGames"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Outdoor Games
                    </span>
                  </Link>
                </li>
                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/musicrooms"}>
                    <span className="flex text-base border-b-2 border-slate-500">
                      Music Rooms
                    </span>
                  </Link>
                </li>

                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/dancerooms"}>
                    <span className="flex text-base border-b-2 border-slate-500 ">
                      Dance Rooms
                    </span>
                  </Link>
                </li>
                <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                  <Link to={"/library"}>
                    <span className="flex text-base border-b-2 border-slate-500 ">
                      Library
                    </span>
                  </Link>
                </li>
                <Link to={"/labsSchool"}>
                  <li className="p-1 whitespace-no-wrap  text-sm md:text-base text-white-600 hover:text-yellow-300 ">
                    <span className="flex text-base border-b-2 border-slate-500 ">
                      Labs
                    </span>
                  </li>
                </Link>
              </ul>
            </li>
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125  mb-1 md:mb-0">
            <Link to={"../gallerySection"}>
              <span className="font-semibold">Work</span>
              </Link>
              </li> */}
            <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150 mb-1 md:mb-0">
              <Link to={"/img"}>
                <span className="font-semibold">Gallery</span>
              </Link>
            </li>
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125  mb-1 md:mb-0">
              <span className="font-semibold">Online Fee</span>
              </li> */}
            <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
              <Link to="../uploadSyllabus">
                <span className="font-semibold">Syllabus</span>
              </Link>
            </li>

            <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
              <Link to="../bookList">
                <span className="font-semibold">Book List</span>
              </Link>
            </li>

            <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
              {/* <a
                href="../assets/Wesite-Mandatory-Disclosure.pdf"
                target="blank"
                className="text-white font-semibold"
              >
                Mandatory Disclosure
              </a> */}
              <Link to="../mandatoryDisclosure">
                <span className="font-semibold">Mandatory Disclosure</span>
              </Link>
            </li>

            
            <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
              <Link to="../cbp">
                <span className="font-semibold">CBP</span>
              </Link>
            </li>
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150 mb-1 md:mb-0">
              <span className="font-semibold">Contact Us</span>
              </li> */}

            {userType === "admin" ? (
              <Link to={"/adminPage"}>
                <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
                  <span className="font-semibold">Admin</span>
                </li>
              </Link>
            ) : userType === "teacher" ? (
              <Link to={"/teacherspage"}>
                <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
                  <span className="font-semibold">Teacher</span>
                </li>
              </Link>
            ) : userType === "student" ? (
              <Link to={"/dashboard"}>
                <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
                  <span className="font-semibold">Student</span>
                </li>
              </Link>
            ) : (
              !user && (
                <Link to={"/login"}>
                  <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
                    <span className="font-semibold">Login</span>
                  </li>
                </Link>
              )
            )}
            {/* <li className="relative mx-1 px-1 py-2 group mr-6 hover:cursor-pointer hover:scale-125 duration-150  mb-1 md:mb-0">
               <Link to={"/login"}>
              <span className="font-semibold">Login</span>
              </Link>
              </li> */}
          </ul>
        </nav>
        {/* Nav  End */}
      </header>
      {openMenu && (
        <nav className="h-32 md:pb-0 bg-[#00000096]">
          <ul className="flex-col">
            <li className="relative mx-1 px-1 py-2 group mr-6 text-white mb-1 md:mb-0 border-b">
              <span className="font-bold">Home</span>
            </li>
            <Link to={"/aboutUs"}>
              <li className="relative mx-1 px-1 py-2 group mr-6  mb-1 md:mb-0 border-b">
                <span className="firstlevel font-bold whitespace-no-wrap text-white">
                  About Us
                </span>
              </li>
            </Link>
            <li className="relative mx-1 px-1 py-2 group mr-6  mb-1 md:mb-0 border-b">
              <Link to={"/login"}>
                <span className="font-bold text-white">Login</span>
              </Link>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default NavbarComponent;
